import { useState } from "react";
import { Get, Set } from "../../../../../Request";
import { useSelector } from "react-redux";
import { amdinManagerClassManagerCombine } from "../../../../../Utils/orderListRoutes";
export const useOrderList = (role, app) => {
  const { user } = useSelector(state => state);
  const [loading, setLoading] = useState({
    list: true,
  });
  const [data, setData] = useState({});
  const [filter, setFilter] = useState({});
  const [showModal, setShowModal] = useState({
    status: false,
    name: "",
  });

  const [nextLoading, setNextLoading] = useState(false);

  const getData = async (dataGet, isApp) => {
    setLoading({ ...loading, list: true });
    setNextLoading(true);
    Get({
      url: renderHeaders()["route"],
      data: { ...dataGet },
    }).then(res => {
      if (dataGet?.limit && isApp) {
        const newData = {
          ...data,
          data: data.data.concat(res.data),
          next_page_url: res.next_page_url,
          current_page: res.current_page
        }
        setData(newData);
      }
      else {
        setData(res);
      }
      setLoading({ ...loading, list: false });
      setNextLoading(false);
    });
  };

  const searchHandler = search => {
    setFilter({ ...filter, search });
    getData({ search, app });
  };
  const pageHandler = (page, limit = 15, isApp) => {
    getData({ ...filter, page, limit, app: isApp }, isApp);
  };
  const sortHandler = (key, value) => {
    setFilter({ ...filter, [key]: value });
    getData({ ...filter, [key]: value });
  };
  const renderHeaders = () => {
    switch (role || user.role) {
      case "owner":
      case "supporter":
      case "financial":
      case "contentmaker":
        return {
          routes: [
            {
              title: "نام مجموعه/کلاس",
              keyName: "name",
              type: "state",
              method: row => {
                if (row) {
                  if (
                    row.model_order == "reserve" ||
                    row.model_order == "contractual_reservation" ||
                    row.model_order == "refund_reserve" ||
                    row.model_order == "refund_reserve_wage" ||
                    row.model_order == "reject_reserve" ||
                    row.model_order == "cancell_reserve_wage" ||
                    row.model_order == "contractual_reservation_installments"
                  ) {
                    return (
                      row &&
                      row.item_reserve_product &&
                      row.item_reserve_product.name
                    );
                  }
                  if (row.model_order == "joinclass") {
                    return (
                      row &&
                      row.class_class_product &&
                      row.class_class_product.name
                    );
                  }
                  if (row.model_order == "walletsharge") {
                    return "--------";
                  }
                } else {
                  return "ثبت نشده";
                }
              },
            },
            ...amdinManagerClassManagerCombine,
          ],
          route: "/order/list_admin",
        };
      case "manager":
        return {
          routes: amdinManagerClassManagerCombine,
          route: "/order/reserve",
        };

      case "classmanager":
        return {
          routes: amdinManagerClassManagerCombine,
          route: "/order/joinclass",
        };
      case "user":
        return {
          routes: [
            {
              title: "نام مجموعه/کلاس",
              keyName: "name",
              type: "state",
              method: row => {
                if (row) {
                  if (
                    row.model_order == "reserve" ||
                    row.model_order == "contractual_reservation" ||
                    row.model_order == "refund_reserve" ||
                    row.model_order == "refund_reserve_wage" ||
                    row.model_order == "reject_reserve" ||
                    row.model_order == "cancell_reserve_wage" ||
                    row.model_order == "contractual_reservation_installments"
                  ) {
                    return (
                      row &&
                      row.item_reserve_product &&
                      row.item_reserve_product.name
                    );
                  }
                  if (row.model_order == "joinclass") {
                    return (
                      row &&
                      row.class_class_product &&
                      row.class_class_product.name
                    );
                  }
                  if (row.model_order == "walletsharge") {
                    return "--------";
                  }
                } else {
                  return "ثبت نشده";
                }
              },
            },
            ...amdinManagerClassManagerCombine
              .filter(route => route.key != "client")
              .filter(Boolean),
          ],
          route: "/client/order",
        };

      default:
        break;
    }
  };
  return {
    loading,
    getData,
    data,
    showModal,
    setShowModal,
    renderHeaders,
    searchHandler,
    pageHandler,
    setFilter,
    sortHandler,
    filter,
    nextLoading
  };
};
